js_add_cart()
function js_add_cart(){
    document.addEventListener('DOMContentLoaded', addCart)
}

function addCart() {
    const products = document.querySelectorAll('.js-add-cart')

    if (products != null) {
        init()
    }

    function init() {
        products.forEach(product => {
            product.addEventListener('click', e => {
                e.preventDefault()
                add(product.dataset.id)
            })
        })
    }

    function add(id) {
        $.ajax({
            url: "/cart/add",
            type: "post",
            data: {
                id: id,
                quantity: 1
            },
            success: () => {
                window.location.href = "/checkout"
            },
            error: err => {
                console.log(err)
            }
        })
    }
}